{
  "eyebrow": "FOR STUDENTS. BY STUDENTS.",
  "title": "The student car sharing platform.",
  "subtitle": "CARii lets students rent cars from other students — affordable, verified and booked in minutes."
}
